/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of AppH5EnvConfig
 */

import { IH5Context } from '../IH5Tracker';
import { ITracker } from 'com/didichuxing/tracker/ITracker';
import AH5EnvConfigSync from 'com/didichuxing/tracker/h5/envconfig/AH5EnvConfigSync';
import AppUtil from 'com/didichuxing/tracker/plugin/utils/AppUtil';
/**
 * 端内H5环境配置
 *
 * @class
 * @implements {IEnvConfigurationItem}
 */
export default class AppH5EnvConfig extends AH5EnvConfigSync {

    private context: IH5Context | undefined;

    /**
     * window.OmegaSDK存在，则说明在端内。
     * @override
     * @inheritDoc
     * @param {IH5Context} context
     * @returns {boolean}
     */
    public validate(context: IH5Context): boolean {
        this.context = context;
        // 当禁止桥接的时候
        if (this.context.disableBridge === true) {
            // 仅同步oid
            if (AppUtil.inEnv()) {
               this.syncNativeOid();
            }
            return false;
        }
        return AppUtil.inEnv();
    }

    /**
     * 同步端上的oid
     */
    private syncNativeOid(resolve?: () => void) {
        const context = this.context;
        // 将context的标记在端内
        if (context) {
            context.isInNative = true;
        }
        AppUtil.fetchAppOmgId().then((oid: string): void => {
            Object.assign(context, {
                // 设置oid
                omgId: oid,
                nativeDone: true
            });
            resolve && resolve();
        });
    }

    /**
     * @override
     * @inheritDoc
     * @param {ITracker} tracker
     * @returns {Promise<void>}
     */
    public beforeDeliver(tracker: ITracker): Promise<void> {
        return new Promise<void>((resolve: () => void): void => {
            if (this.context) {
                this.syncNativeOid(resolve);
            }
        });
    }

    /**
     * @override
     * @inheritDoc
     * @returns {string}
     */
    protected getExtraPluginsUrlName(): string {
        return 'omega.default.app.extra.plugins.min.js';
    }
}
